import React, { createContext, useState, useEffect } from "react";
import { getWelcomeCampaignSummary } from "../../../utils/services/APP/WelcomeCampaign/getWelcomeCampaignSummary";
import { useValidToken } from "../../../hooks/useValidToken";

export const WelcomeCampaignContext = createContext();

export const WelcomeCampaignProvider = ({ children }) => {
  const [welcomeCampaignSummary, setWelcomeCampaignSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0); // 0-based (MUI DataGrid)
  const [pageSize, setPageSize] = useState(50);

  const { isValid, authLoading } = useValidToken();

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const res = await getWelcomeCampaignSummary(page + 1, pageSize); // 1-based para backend
      setWelcomeCampaignSummary(
        res.data.map((item) => ({ ...item, id: item.cipId }))
      );
      setTotal(res.total);
    } catch (error) {
      console.error("[WelcomeCampaignContext] Error loading summary:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!isValid || authLoading) return;
    fetchSummary();
  }, [page, pageSize, authLoading, isValid]);

  return (
    <WelcomeCampaignContext.Provider
      value={{
        welcomeCampaignSummary,
        total,
        page,
        pageSize,
        loading,
        setPage,
        setPageSize,
        fetchSummary,
      }}
    >
      {children}
    </WelcomeCampaignContext.Provider>
  );
};
